<div class="font-label-large">{{ statusName() | translate }}</div>
